<template>
    <div>
        
		<div class="profile-nav-bg" style="background-image: url('/images/bg-profile.jpg'); height: 200px !important"></div>
		 
        <a-row type="flex" :gutter="40" align="top" style="margin-top: -70px; padding-left: 24px; padding-right: 24px;">
            <a-col :span="24" :md="8" class="mb-24">
                <visitor-history-card />
            </a-col>
            <a-col :span="24" :md="8" class="mb-24">
                <take-appointment-list />
            </a-col>
            <a-col :span="24" :md="8" class="mb-24" style="">
                <visitor-profile-information />
            </a-col>
        </a-row>
    </div>
</template>

<script>
import { useAuthStore } from '../stores/auth-store';
import { navigationMixin } from '../mixins/navigation-mixin.js';
import { mapState } from 'pinia';
import VisitorHistoryCard from '../views/visitor-dashboard/AppointmentHistoryList.vue';
import TakeAppointmentList from '../views/visitor-dashboard/TakeAppointmentList.vue';
import VisitorProfileInformation from '../views/visitor-dashboard/VisitorProfileInformation.vue';

export default {
    name: "VisitorDashboard",
    components: {
        VisitorHistoryCard,
        TakeAppointmentList,
        VisitorProfileInformation
    },
    mixins: [ navigationMixin ],
    computed: {
        ...mapState(useAuthStore, [ 'currentUser', 'profile' ] ),
        profileImage() {
            if (this.profile && this.profile.imageUrl &&  this.profile.imageUrl.length > 0) {
                return this.profile.imageUrl;
            }
            return '/images/default-avatar.jpg';
        }
    }
}
</script>

<style>

</style>